(() => {
  const boot = () => {
    const bar = document.querySelector('[data-mobile-app-bar]');
    if (!bar || bar.dataset.initialised === 'true') return;
    bar.dataset.initialised = 'true';

    const link = bar.querySelector('[data-mobile-app-link]');
    const description = bar.querySelector('[data-mobile-app-description]');
    const userAgent = window.navigator.userAgent || '';
    const platform = window.navigator.platform || '';
    const isIPadOS =
      platform === 'MacIntel' && Number(window.navigator.maxTouchPoints || 0) > 1;
    const isIOS = /iPad|iPhone|iPod/i.test(userAgent) || isIPadOS;

    if (link) {
      if (isIOS) {
        link.href = bar.dataset.iosUrl;
        link.textContent = 'App Store';
        if (description) description.textContent = 'Faster shopping on iPhone or iPad';
        bar.setAttribute('aria-label', 'Farmers Stop app for iPhone and iPad');
      } else {
        link.href = bar.dataset.androidUrl;
        link.textContent = 'Google Play';
        if (description) description.textContent = 'Faster shopping on Android';
        bar.setAttribute('aria-label', 'Farmers Stop app for Android');
      }
    }

    try {
      if (window.sessionStorage.getItem('fsMobileAppBarDismissed') === 'true') {
        bar.hidden = true;
      }
    } catch (error) {
      // Storage can be unavailable in private browsing; the bar still works.
    }

    bar.querySelector('[data-mobile-app-bar-close]')?.addEventListener('click', () => {
      bar.hidden = true;
      try {
        window.sessionStorage.setItem('fsMobileAppBarDismissed', 'true');
      } catch (error) {
        // Closing the bar must not depend on storage access.
      }
    });
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
